import { render, staticRenderFns } from "./app-alarm-dialog.vue?vue&type=template&id=2b1a6026&scoped=true&"
import script from "./app-alarm-dialog.vue?vue&type=script&lang=js&"
export * from "./app-alarm-dialog.vue?vue&type=script&lang=js&"
import style0 from "./app-alarm-dialog.vue?vue&type=style&index=0&id=2b1a6026&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b1a6026",
  null
  
)

export default component.exports